export default __webpack_public_path__ + "static/terran_collective_logo_white-9be0db83b9cbbcbce979fd7b3abf3e46.svg";